module.exports = __webpack_public_path__ + "img/404.1a2f7986.png";